/** Map of file extensions to MIME types for document rendering */
const EXTENSION_TO_MIME: Record<string, string> = {
	pdf: 'application/pdf',
	docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	doc: 'application/msword',
	txt: 'text/plain',
	md: 'text/markdown',
};

/** Map of MIME types to file extensions for downloads */
const MIME_TO_EXTENSION: Record<string, string> = {
	'application/pdf': 'pdf',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
	'application/msword': 'doc',
	'text/plain': 'txt',
	'text/markdown': 'md',
};

/** Resolve a MIME type from a file extension or filename */
export function getMimeTypeFromExtension(fileType: string, fileName?: string): string {
	const ext = (fileType || fileName?.split('.').pop() || '').toLowerCase().trim();
	return EXTENSION_TO_MIME[ext] ?? 'application/octet-stream';
}

/** Resolve a file extension from a MIME type */
export function getExtensionFromMimeType(mimeType: string): string {
	return MIME_TO_EXTENSION[mimeType] ?? '';
}
